import { PrimaryButton } from '@changegps/horizon-component-library';
import { Box, Divider } from '@mui/material';

import { ControlledInputs } from '@/components';
import {
  chargeableRateOptions,
  positionTypeOptions,
} from '@/features/settings/hooks/constants';

import { useCompanyDetails, useUserDetailsFormContext } from '../hooks';

export const UserDetailsForm = () => {
  const form = useUserDetailsFormContext();
  const { loading, handleUseCompanyDetails } = useCompanyDetails(form);

  return (
    <Box>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr auto 1fr',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
          }}
        >
          <ControlledInputs.TextField
            ControllerProps={{
              control: form.control,
              name: `firstName`,
            }}
            label="First Name"
          />
          <ControlledInputs.TextField
            ControllerProps={{
              control: form.control,
              name: `lastName`,
            }}
            label="Last Name"
          />
          <ControlledInputs.TextField
            ControllerProps={{
              control: form.control,
              name: `companyPosition`,
            }}
            label="Company Position"
          />

          <ControlledInputs.Select
            ControllerProps={{
              control: form.control,
              name: `positionType`,
            }}
            optionKeys={{ label: 'label', value: 'value' }}
            options={positionTypeOptions}
            label="Position Type"
          />
          <ControlledInputs.Select
            ControllerProps={{
              control: form.control,
              name: `chargeableRate`,
            }}
            optionKeys={{ label: 'label', value: 'value' }}
            options={chargeableRateOptions}
            label="Chargeable Rate"
          />
          <ControlledInputs.TextField
            ControllerProps={{
              control: form.control,
              name: `personalQual`,
            }}
            label="Personal Qualification"
          />
        </Box>
        <Box>
          <Divider
            orientation="vertical"
            sx={{
              marginX: '28px',
            }}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '17px',
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <PrimaryButton disabled={loading} onClick={handleUseCompanyDetails}>
              Use Company Details
            </PrimaryButton>
          </Box>

          <ControlledInputs.TextField
            ControllerProps={{
              control: form.control,
              name: `address`,
            }}
            label="Address"
          />

          <ControlledInputs.TextField
            ControllerProps={{
              control: form.control,
              name: `suburb`,
            }}
            label="Suburb"
          />
          <ControlledInputs.TextField
            ControllerProps={{
              control: form.control,
              name: `state`,
            }}
            label="State"
          />
          <ControlledInputs.TextField
            ControllerProps={{
              control: form.control,
              name: `postCode`,
            }}
            label="Post Code"
          />
          <ControlledInputs.TextField
            ControllerProps={{
              control: form.control,
              name: `phoneNumber`,
            }}
            label="Phone Number"
          />
        </Box>
      </Box>
    </Box>
  );
};
